module.exports = __webpack_public_path__ + "img/sld_tvm_dark.32f2b59d.svg";